import { StatusChip, StatusChipGroup } from '@locus-taxy/encore-mui';

interface EntityStatusChipsProps {
  status?: string;
  subStatus?: string;
}

export default function EntityStatusChips({
  status,
  subStatus,
}: EntityStatusChipsProps) {
  // If neither status nor substatus exists, return null
  if (!status && !subStatus) {
    return null;
  }

  // If both status and substatus exist, use StatusChipGroup
  if (status && subStatus) {
    return (
      <StatusChipGroup
        segments={[
          { label: status, color: 'neutral' as const },
          { label: subStatus, color: 'neutral' as const },
        ]}
      />
    );
  }

  // If only one exists, use single StatusChip
  return <StatusChip label={status || subStatus} color="neutral" />;
}
